<template>
  <div>
    <div class="container-fluid fixed-top p-4">
      <div class="col-12">
<!--        <div v-if="canLogin" class="d-flex justify-content-end">-->
<!--          <div>-->
<!--            <inertia-link v-if="$page.props.user" :href="route('project.dashboard', {...global_url_params})" class="text-muted">-->
<!--              Dashboard-->
<!--            </inertia-link>-->

<!--            <template v-else>-->
<!--              <inertia-link :href="route('login')" class="text-muted">-->
<!--                Log in-->
<!--              </inertia-link>-->

<!--              <inertia-link v-if="canRegister" :href="route('register')" class="ml-4 text-muted">-->
<!--                Register-->
<!--              </inertia-link>-->
<!--            </template>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>

    <div class="container-fluid my-5 pt-5 px-5">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-4">
                <div class="card text-center">
                    <div class="card-body">
                        <div class="logo">
                            <img class="img-fluid" :src="theme_logo" alt="">
                        </div>
                        <h1 class="mt-4">{{ active_tenant.name }}</h1>

                        <hr>

                        <div class="mb-3">
                            <inertia-link :href="route('project.dashboard', {...global_url_params})"
                                          class="btn btn-primary">
                                {{ $page.props.user ? 'View Projects' : 'Login' }}
                            </inertia-link>
                            <inertia-link v-if="!$page.props.user"
                                          :href="route('project.dashboard', route('project.dashboard', {...global_url_params}))"
                                          class="btn btn-secondary ml-2">
                                Register
                            </inertia-link>
                        </div>

                    </div>

<!--                    <inertia-link v-if="$page.props.user" :href="route('project.dashboard', {...global_url_params})" class="text-muted">-->
<!--                        Dashboard-->
<!--                    </inertia-link>-->

<!--                    <template v-else>-->
<!--                        <inertia-link :href="route('login')" class="text-muted">-->
<!--                            Log in-->
<!--                        </inertia-link>-->

<!--                        <inertia-link v-if="canRegister" :href="route('register')" class="ml-4 text-muted">-->
<!--                            Register-->
<!--                        </inertia-link>-->

                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<style scoped>

</style>

<script>
import jQuery from "jquery";
import MarkdownText from "@/Components/Common/MarkdownText";

export default {
    components: {MarkdownText},
    props: {
        canLogin: Boolean,
        canRegister: Boolean,
        laravelVersion: String,
        phpVersion: String,
    },

    mounted() {
        jQuery(($) => {
            if( this.theme_background ){
                $('html')
                    .css({'background-image': `url(${this.theme_background})`})
                    .addClass('has-background');
            }
        });
    }

}
</script>
